module.exports = __webpack_public_path__ + "img/shield.fca915e2.svg";